import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetch as fetchAvatars } from 'actions/registration';
import * as FatePropTypes from 'fera-prop-types/fate';
import Loading from 'components/Loading';

import PurchaseFaceComponent from './PurchaseFaceComponent';

// TODO: see if we can get this from the server data somehow rather than magic-numbering it
const FACE_CHANGE_FATE_COST = 30;

export class PurchaseFace extends Component {
  state = {
    hasLoadedAvatars: false,
  }

  componentDidMount = async () => {
    const { dispatch } = this.props;
    await dispatch(fetchAvatars());
    this.setState({ hasLoadedAvatars: true });
  }

  handleGoToBuyFate = () => {
    const { history } = this.props;
    history.push('/fate');
  }

  render = () => {
    const {
      avatars,
      currentFate,
      isFree,
      onRequestClose,
      data: activePurchase,
    } = this.props;
    const { hasLoadedAvatars } = this.state;

    if (!hasLoadedAvatars) {
      return <Loading spinner />;
    }

    return (
      <PurchaseFaceComponent
        activePurchase={activePurchase}
        avatars={avatars}
        currentFate={currentFate}
        isFree={isFree}
        fateCost={FACE_CHANGE_FATE_COST}
        onGoToBuyFate={this.handleGoToBuyFate}
        onRequestClose={onRequestClose}
      />
    );
  }
}

PurchaseFace.propTypes = {
  avatars: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentFate: PropTypes.number.isRequired,
  data: FatePropTypes.fateCard.isRequired,
  dispatch: PropTypes.func.isRequired,
  isFree: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
};

PurchaseFace.defaultProps = {
  isFree: false,
};

const mapStateToProps = ({
  fate: { data: { currentFate } },
  registration: { avatars },
}) => ({
  avatars,
  currentFate,
});

export default withRouter(connect(mapStateToProps)(PurchaseFace));